import { Image } from "@mantine/core";
import NavBarLink from "../NavBarLink";
import NavBarUserProfile from "../NavBarUserProfile";
import styles from "./NavbarComponent.module.css";

function NavBarComponent() {
    return (
        <>
            <div className={styles.spacer} />
            <div className={styles.container}>
                <div>
                    <div className={styles.logoContainer}>
                        <Image src={'/assets/logo-only-symbol.png'} maw={70} alt="Logo" />
                    </div>
                    <div className={styles.linksContainer}>
                        <NavBarLink
                            icon={'category'}
                            color={"aed581"}
                            label={"Articoli"}
                            url={"/articleDetails"}
                        />
                        <NavBarLink
                            icon={'add_to_photos'}
                            color={"aed581"}
                            label={"Immagini"}
                            url={"/uploadImages"}
                        />
                        <NavBarLink
                            icon={'storefront'}
                            color={"aed581"}
                            label={"Marketplace"}
                            url={"/marketplace-status"}
                        />
                        <NavBarLink
                            icon={'shopping_cart'}
                            color={"aed581"}
                            label={"Ordini"}
                            url={"/orders"}
                        />
                        {/* Commented out for future use
                        <NavBarLink 
                            icon={'csv'} 
                            color={"aed581"} 
                            label={"CSV"} 
                            url={"/uploadCsv"} 
                        />
                        <NavBarLink 
                            icon={'data_table'} 
                            color={"aed581"} 
                            label={"Inserimento Dati"} 
                            url={"/insertData"} 
                        />
                        */}
                    </div>
                </div>
                <NavBarUserProfile />
            </div>
        </>
    );
}

export default NavBarComponent;
